import { Component, input, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ContentScoringMethod, TextUtils } from '@mira-avant/mtlibs';
import { DropdownControl } from '../../../controls/setup-wizard/dropdown-control/dropdown-control';

@Component({
	selector: 'app-scoring-method-dropdown-field',
	imports: [DropdownControl],
	standalone: true,
	templateUrl: './scoring-method-dropdown-field.html',
	styleUrl: './scoring-method-dropdown-field.scss',
})
export class ScoringMethodDropdownField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
	options = signal<{ value: string; label: string }[]>(
		Object.values(ContentScoringMethod).map(value => ({
			value,
			label: TextUtils.convertSnakeCaseToTitleCase(value),
		}))
	);
}
